import React from 'react';
import styled from 'styled-components';
import Box from '../components/Box/Box.js';
import { get } from '../constants.js';

/**
 * The Getting Started page's CoreFeaturesCardGrid component accepts a `children` prop, which you can use to pass in CoreFeaturesCard components to diplay in a grid.
 *
 * It will display 3 cards in a horizontal grid at 1024px and above, then degrade to a column of cards below 1024px.
 *
 * The action passed to a CoreFeaturesCard button's onClick handler is of type CoreFeaturesCardAction. Every
 * CoreFeaturesCardAction should have a type, a destination url, label, and tracking object,
 * which itself consists of a destination and a type.
 *
 *
 */

const CoreFeaturesCardGrid = ({
  children,
  as = 'div',
  sx: sxProp
}) => {
  console.warn('CoreFeaturesCardGrid is deprecated. Use the v1.1 layout for Getting Started screens instead. See: https://www.fuegokit.design/react-storybook/?path=/story/patterns-getting-started-page--getting-started-page-growth');
  return /*#__PURE__*/React.createElement(CardGrid, {
    as: as,
    sx: sxProp
  }, children);
};
CoreFeaturesCardGrid.displayName = "CoreFeaturesCardGrid";
const CardGrid = styled(Box).withConfig({
  displayName: "CoreFeaturesCardGrid__CardGrid",
  componentId: "sc-ckhinj-0"
})(["display:flex;gap:16px;flex-wrap:wrap;justify-content:space-evenly;width:100%;max-width:1024px;@media (min-width:", "){flex-wrap:nowrap;}@media (min-width:", "){gap:16px;width:100%;}"], get('breakpoints.1'), get('breakpoints.2'));
CoreFeaturesCardGrid.displayName = 'CoreFeaturesCardGrid';
var CoreFeaturesCardGrid$1 = CoreFeaturesCardGrid;

export { CoreFeaturesCardGrid$1 as default };
